import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2 } from 'lucide-react';
import { Section } from './ui/Section';
const bonos = [{
  num: 'BONO 1',
  name: 'Mapa de Rutas EBI Tramo 2',
  desc: 'Calendario anual con secuencia semanal para las 5 áreas de este kit. Tu año de Física · Historia · Geografía y Ciudadanía organizado en una sola hoja. Sabés exactamente qué tomo abrir cada semana. Sin dudar. Sin improvisar.',
  val: '$120 UYU',
  includes: ['Calendario anual completo mes a mes', 'Ruta trimestral por tomo', 'Combinaciones inteligentes entre áreas', 'Checklist mensual docente', 'Guía de emergencia para días sin preparación', 'Banco de preguntas disparadoras por área', 'Hoja de ruta personal imprimible']
}, {
  num: 'BONO 2',
  name: 'Planificador Semanal Clase Lista',
  desc: 'Plantilla lista para completar cada semana. El sistema que te permite preparar cualquier clase de Historia · Geografía Física y Química o Ciudadanía en menos de 15 minutos. Sin armar nada desde cero.',
  val: '$100 UYU',
  includes: ['Sistema Clase Lista en 3 pasos', 'Plantilla semanal completa', 'Plantilla compacta para semanas difíciles', 'Plantilla de emergencia para el domingo', 'Ejemplos resueltos por área', 'Hoja de seguimiento semanal', 'Pack de hojas fotocopiables']
}, {
  num: 'BONO 3',
  name: 'Guía de Comunicación con Familias',
  desc: '+70 mensajes listos para enviar a las familias. Para cuando tu estudiante brilló en Historia. Para cuando necesitás explicar la evaluación de Geografía. Para cuando querés compartir un logro de Ciudadanía. Copiás · pegás y enviás.',
  val: '$80 UYU',
  includes: ['Mensajes de bienvenida e inicio de año', 'Mensajes positivos sobre avances por área', 'Mensajes de reunión individual', 'Mensajes por dificultades de aprendizaje', 'Mensajes de cierre y fin de año', 'Plantillas editables para personalizar', 'Calendario de comunicación anual']
}, {
  num: 'BONO 4',
  name: 'Kit de Actividades Rápidas',
  desc: 'Cuando el día se complica, abrís este bono y en 2 minutos ya sabés qué hacer con el grupo. Actividades específicas de Historia · Geografía · Física y Química Ciencias de la Tierra y Ciudadanía. Sin fotocopias. Sin preparación previa.',
  val: '$80 UYU',
  includes: ['+58 actividades listas para usar', 'Actividades de arranque rápido', 'Actividades para recuperar el foco', 'Actividades sin materiales ni fotocopias', '5 actividades específicas por cada área del kit', 'Dinámicas de convivencia express', 'Índice de rescate rápido por situación']
}, {
  num: 'BONO 5',
  name: 'Banco de Evaluaciones Express',
  desc: 'Evaluá rápido · con criterio y sin armar nada desde cero. +70 instrumentos listos para Física y Química · Ciencias de la Tierra Historia · Geografía y Ciudadanía.',
  val: '$70 UYU',
  includes: ['20 tickets de salida por área', '5 formatos de autoevaluación visual', '10 mini rúbricas por competencia EBI', '25 preguntas rápidas por área curricular', '5 preguntas integradoras anuales', '3 formatos de observación docente', 'Escalas de logro para el aula']
}, {
  num: 'BONO 6',
  name: 'Manual Antidomingo',
  desc: 'Dejá de empezar cada semana desde cero. El sistema que convierte el viernes en el día más importante de tu semana docente. Para que el domingo deje de ser tu segundo día de trabajo y vuelva a ser tuyo de verdad.',
  val: '$50 UYU',
  includes: ['Diagnóstico del domingo docente', 'Sistema antidomingo en 3 niveles', 'Método de los 30 minutos', 'Checklist del viernes completo', 'Plan de rescate del domingo', 'Árbol de decisión semanal', 'Hoja lunes resuelto lista para usar', 'Guía de bienestar docente anual']
}];
export const Bonos = () => {
  return <Section background="cream" data-id="element-18">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-19">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-100 text-amber-600 mb-6" data-id="element-20">
          <Gift className="w-8 h-8" data-id="element-21" />
        </div>
        <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-4" data-id="element-22">
          🎁 6 BONOS ESTRATÉGICOS
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-12" data-id="element-23">
        {bonos.map((bono, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="bg-white rounded-2xl p-6 shadow-sm border border-amber-100 flex flex-col relative overflow-hidden" data-id="element-24">
            <div className="absolute top-0 right-0 bg-amber-100 text-amber-800 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-25">
              {bono.val} → GRATIS
            </div>
            <div className="text-amber-600 font-bold text-sm mb-2 mt-2" data-id="element-26">
              {bono.num}
            </div>
            <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-27">
              {bono.name}
            </h3>
            <p className="text-stone-600 text-sm font-medium leading-relaxed mb-4" data-id="element-28">
              {bono.desc}
            </p>
            <div className="mt-auto pt-4 border-t border-stone-100" data-id="element-29">
              <p className="text-xs font-bold text-stone-800 mb-2 uppercase tracking-wider" data-id="element-30">
                Lo que incluye:
              </p>
              <ul className="space-y-1.5" data-id="element-31">
                {bono.includes.map((item, i) => <li key={i} className="flex items-start gap-2 text-xs text-stone-600" data-id="element-32">
                    <CheckCircle2 className="w-3.5 h-3.5 text-amber-500 shrink-0 mt-0.5" data-id="element-33" />
                    <span data-id="element-34">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>)}
      </div>

      <div className="max-w-2xl mx-auto bg-amber-50 rounded-2xl p-6 md:p-8 text-center border border-amber-200" data-id="element-35">
        <p className="text-stone-600 font-medium mb-2" data-id="element-36">
          Valor total de los 6 bonos:{' '}
          <span className="line-through" data-id="element-37">$500 UYU</span>
        </p>
        <p className="text-2xl md:text-3xl font-extrabold text-amber-700" data-id="element-38">
          Incluidos con tu Kit + Bonos
        </p>
      </div>
    </Section>;
};